import React from 'react';
import '../../assets/css/shimmer.css'

const LoaderCertificat = () => {

    return (

        <div className="certificates">
            <div className="block-title">
                <h6 className="title">گواهینامه ها</h6>
            </div>
            <div className="row">
                <div className=" col-lg-12 col-xl-6">
                    <div className="certificate-item d-flex shimmerBox">
                        <div className="certificate-logo">
                            <div className="shine shimmerBoxIn"></div>
                        </div>
                        <div className="certificate-content">
                            <div className="title"><div className="shine d-block shimmerLine"></div></div>
                            <div className="certificate-date"><div className="shine d-block shimmerLine"></div></div>
                        </div>
                    </div>
                </div>
                <div className=" col-lg-12 col-xl-6">
                    <div className="certificate-item d-flex shimmerBox">
                        <div className="certificate-logo">
                            <div className="shine shimmerBoxIn"></div>
                        </div>
                        <div className="certificate-content">
                            <div className="title"><div className="shine d-block shimmerLine"></div></div>
                            <div className="certificate-date"><div className="shine d-block shimmerLine"></div></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
export default LoaderCertificat;